import React from "react";
import PropTypes from "prop-types";
import { Button } from "@qgiv/core-donor";
import "./FundraisingDashboardButton.scss";

const FundraisingDashboardButton = ({
    hasActiveGlobalAccount,
    hasSocialLogins,
    isLoggedIn,
    donorActionUrl,
    eventHome,
    myFundraisingDashboard,
}) => {
    const handleDashboardButtonClick = () => {
        const eventLogIn = `${eventHome}login/`;

        if (isLoggedIn) {
            // Open a new tab with the fundraising Dashboard
            window.open(myFundraisingDashboard, "_blank");
        } else if (!isLoggedIn && !hasSocialLogins) {
            // Open a new tab with the new log in screen
            window.open(donorActionUrl, "_blank");
        } else {
            // Open a new tab with the legacy event log in page as social
            // logins are not part of the new log in screens
            window.open(eventLogIn, "_blank");
        }
    };

    // Only render the "My Fundraising Dashboard" button if the user has
    // activated their account
    if (hasActiveGlobalAccount) {
        return (
            <div className="fundraising-dashboard-button grid">
                <div className="col col--12 -padding-bottom--15">
                    <div className="fundraising-dashboard-button__container">
                        <div className="fundraising-dashboard-button__content">
                            <Button
                                type="button"
                                onClick={handleDashboardButtonClick}
                            >
                                My Fundraising Dashboard
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

FundraisingDashboardButton.propTypes = {
    hasActiveGlobalAccount: PropTypes.bool.isRequired,
    hasSocialLogins: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    donorActionUrl: PropTypes.string.isRequired,
    eventHome: PropTypes.string.isRequired,
    myFundraisingDashboard: PropTypes.string.isRequired,
};

export default FundraisingDashboardButton;
